/**
 * Entidad Adicional Admin
 *
 * WHATSAPP_EXCEDENTE no es un tipo comercial: es el ancla interna de
 * facturación de overage. No se lista ni se asigna desde este CRUD.
 */

export type AdicionalTipo =
  | 'GENERAL'
  | 'WHATSAPP_MENSAJES'
  | 'EMAIL_MENSAJES'
  | 'COOFIT_CONEXION'
  | 'COOFIT_MARKETING'
  | 'COOFIT_WHATSAPP_BOT'
  | 'CONSULTORIO_EXTRA'
  | 'PROFESIONAL_EXTRA';

export const ADICIONAL_TIPO_LABELS: Record<AdicionalTipo, string> = {
  GENERAL: 'General',
  WHATSAPP_MENSAJES: 'Recarga WhatsApp',
  EMAIL_MENSAJES: 'Email',
  COOFIT_CONEXION: 'Coofit Conexión',
  COOFIT_MARKETING: 'Coofit Marketing',
  COOFIT_WHATSAPP_BOT: 'Coofit Agenda WhatsApp',
  CONSULTORIO_EXTRA: 'Consultorio extra',
  PROFESIONAL_EXTRA: 'Profesional extra',
};

export interface AdicionalPersistence {
  id: number;
  nombre: string;
  descripcion: string;
  precioUnitario: number;
  unidad: string;
  tipo?: AdicionalTipo;
  cupoMensajes?: number | null;
  esRecurrente: boolean;
  activo: boolean;
  fechaAlta?: Date | string;
}

export class Adicional {
  private constructor(
    private readonly _id: number,
    private readonly _nombre: string,
    private readonly _descripcion: string,
    private readonly _precioUnitario: number,
    private readonly _unidad: string,
    private readonly _tipo: AdicionalTipo,
    private readonly _cupoMensajes: number | null,
    private readonly _esRecurrente: boolean,
    private readonly _activo: boolean,
    private readonly _fechaAlta?: Date
  ) {}

  static create(
    id: number,
    nombre: string,
    descripcion: string,
    precioUnitario: number,
    unidad: string,
    esRecurrente: boolean,
    activo: boolean,
    fechaAlta?: Date,
    tipo: AdicionalTipo = 'GENERAL',
    cupoMensajes: number | null = null
  ): Adicional {
    return new Adicional(
      id,
      nombre,
      descripcion || '',
      precioUnitario,
      unidad || '',
      tipo,
      cupoMensajes,
      esRecurrente,
      activo,
      fechaAlta
    );
  }

  static reconstitute(data: AdicionalPersistence): Adicional {
    return new Adicional(
      data.id,
      data.nombre,
      data.descripcion || '',
      data.precioUnitario,
      data.unidad || '',
      data.tipo || 'GENERAL',
      data.cupoMensajes ?? null,
      data.esRecurrente,
      data.activo,
      data.fechaAlta
        ? typeof data.fechaAlta === 'string'
          ? new Date(data.fechaAlta)
          : data.fechaAlta
        : undefined
    );
  }

  get id(): number {
    return this._id;
  }
  get nombre(): string {
    return this._nombre;
  }
  get descripcion(): string {
    return this._descripcion;
  }
  get precioUnitario(): number {
    return this._precioUnitario;
  }
  get unidad(): string {
    return this._unidad;
  }
  get tipo(): AdicionalTipo {
    return this._tipo;
  }
  get cupoMensajes(): number | null {
    return this._cupoMensajes;
  }
  get esRecurrente(): boolean {
    return this._esRecurrente;
  }
  get activo(): boolean {
    return this._activo;
  }
  get fechaAlta(): Date | undefined {
    return this._fechaAlta;
  }

  isActive(): boolean {
    return this._activo;
  }

  isMessagePack(): boolean {
    return this._tipo === 'WHATSAPP_MENSAJES' || this._tipo === 'EMAIL_MENSAJES';
  }

  isCoofitConexion(): boolean {
    return this._tipo === 'COOFIT_CONEXION';
  }

  isCoofitMarketing(): boolean {
    return this._tipo === 'COOFIT_MARKETING';
  }

  isCoofitWhatsAppBot(): boolean {
    return this._tipo === 'COOFIT_WHATSAPP_BOT';
  }

  isConsultorioExtra(): boolean {
    return this._tipo === 'CONSULTORIO_EXTRA';
  }

  isProfesionalExtra(): boolean {
    return this._tipo === 'PROFESIONAL_EXTRA';
  }
}
